'use client'

/**
 * Skip-to-content link (JO2-249).
 *
 * `focus-visible:`, not `focus:`: after a client-side navigation Next focuses
 * the first element of the changed segment, which is this link, with no
 * keyboard involved. With `focus:` it then showed over the logo (reproduced in
 * Chromium and Firefox on www.jotul.com, 2026-10-26).
 *
 * <main> is made focusable only when the link is activated, and loses it on
 * blur. A permanent `tabIndex={-1}` on <main> made every mouse click inside the
 * content focus <main>, so the next Tab restarted at the top of the page
 * instead of continuing from the click point (Chromium, Firefox).
 */
export function SkipLink({targetId, label}: {targetId: string; label: string}) {
  return (
    <a
      href={`#${targetId}`}
      onClick={() => {
        const target = document.getElementById(targetId)
        if (!target) return
        target.setAttribute('tabindex', '-1')
        target.focus()
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true})
      }}
      className="sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:left-4 focus-visible:top-4 focus-visible:z-[9999] focus-visible:rounded-md focus-visible:bg-background focus-visible:px-4 focus-visible:py-2 focus-visible:text-foreground focus-visible:shadow-lg focus-visible:outline-2 focus-visible:outline-primary"
    >
      {label}
    </a>
  )
}
